export const CONFIRM_UPDATE = 'CONFIRM_UPDATE'
export const TOKEN_MODAL = 'TOKEN_MODAL'
export const INPUT_MODAL = 'INPUT_MODAL'



// WEBPACK FOOTER //
// ./src/constants/ModalTypes.js